import React from 'react'

export default function Footer() {
  return (
    <footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <script>document.write(new Date().getFullYear())</script>
                 © Olectra.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by <a href="https://www.transglobalgeomatics.com/" target= "_blank"rel="noopener noreferrer" class="text-decoration-underline">Trans Global Geomatics Pvt Ltd</a>
                </div>
            </div>
        </div>
    </div>
</footer>
  )
}
